import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=2cac6628&scoped=true&"
import script from "./GroupsList.vue?vue&type=script&lang=js&"
export * from "./GroupsList.vue?vue&type=script&lang=js&"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=2cac6628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cac6628",
  null
  
)

export default component.exports